import TableStackedBar from './table-stacked-bar';

export default TableStackedBar;
